import { createAsyncThunk } from "@reduxjs/toolkit";
import sdkProvider from "../../../../client/sdkProvider";
import logger from "../../../../lib/logger";

const loadLoyaltyIsBenefitAvailable = createAsyncThunk(
  "config/loadLoyaltyIsBenefitAvailable",
  async (loyaltyBenefitType, { rejectWithValue }) => {
    try {
      const identitySdk = await sdkProvider("identity");
      const isAuthenticated = await identitySdk.customer.isAuthenticated();
      if (!isAuthenticated) {
        return { loyaltyBenefitType, isAuthenticated: false };
      }

      const loyaltySdk = await sdkProvider("loyalty");
      const customerTierId = await loyaltySdk.getCustomerTierId();
      if (customerTierId) {
        const benefitAvailableForTier =
          await loyaltySdk.isBenefitAvailableForTier(
            customerTierId,
            loyaltyBenefitType,
          );

        return {
          loyaltyBenefitType,
          isAuthenticated: true,
          isBenefitAvailable: benefitAvailableForTier,
        };
      }

      return {
        loyaltyBenefitType,
        isAuthenticated: true,
        isBenefitAvailable: false,
      };
    } catch (error) {
      if (error.name !== "LoyaltyNotSupportedError") {
        error.message = `loadLoyaltyIsBenefitAvailable failed with error: ${error.message}`;
        logger.error(error);
      }

      return rejectWithValue(error);
    }
  },
);

export default loadLoyaltyIsBenefitAvailable;
